import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Helper estándar de shadcn — combina clsx + tailwind-merge.
// Permite condicionales (clsx) y resolver conflictos de utilidades (tailwind-merge).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
